var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2509",
    "data-name": "Grupo 2509",
    transform: "translate(-3298.602 -4076)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1389",
    "data-name": "Ret\\xE2ngulo 1389",
    width: 35,
    height: 35,
    rx: 5,
    transform: "translate(3333.602 4076) rotate(90)",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_466",
    "data-name": "Caminho 466",
    d: "M3818.643,4092.592l4,4.193,5.006-6.82",
    transform: "translate(-507.043)",
    fill: "none",
    stroke: "#d3ff9a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBackground);
export default __webpack_public_path__ + "static/media/check-background.484ec7088e88b9b2339b5de333e1f8e1.svg";
export { ForwardRef as ReactComponent };